{
  "endTime": "Час завершення",
  "startTime": "Час початку",
  "time": "Час"
}
